module.exports = __webpack_public_path__ + "b9b060ad5.jpg";